
//module WebApp.Scripts.ts.app.hr.models {

    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

    // More info: http://frhagn.github.io/Typewriter/

    

    

    
    export enum SignalRUpdateTypes {
        Conversation = 0,
        
    }
    export enum Sorting {
        Alphabet = 0,
        CreationDate = 1,
        
    }
    export enum Weekday {
        Monday = 0,
        Tuesday = 1,
        Wednesday = 2,
        Thursday = 3,
        Friday = 4,
        Saturday = 5,
        Sunday = 6,
        
    }
    export enum PMS_Types {
        ASA = 0,
        
    }
    export enum EnergyType {
        Power = 0,
        Heat = 1,
        Water = 2,
        
    }
    export enum FileProvider {
        LocalDisk = 0,
        AzureBlob = 1,
        
    }
    export enum ApplicationStatus {
        open = 0,
        working = 1,
        rejected = 2,
        talentpool = 3,
        closed = 4,
        
    }
    export enum PmsGender {
        unknown = 0,
        male = 1,
        female = 2,
        family = 3,
        company = 4,
        
    }
    export enum PmsLanguage {
        de = 0,
        it = 1,
        en = 2,
        fr = 3,
        spanish = 4,
        dutch = 5,
        russian = 6,
        chinese = 7,
        japanese = 8,
        arabic = 9,
        portuguese = 10,
        turkish = 11,
        polish = 12,
        korean = 13,
        other = 14,
        
    }
    export enum PmsReservationState {
        offer = 0,
        waiting = 1,
        option = 2,
        confirmed = 3,
        contingent = 4,
        cancelled = 5,
        
    }
    export enum PmsRoomReservationState {
        offer = 0,
        waiting = 1,
        option = 2,
        confirmed = 3,
        room_fix = 4,
        contingent = 5,
        checked_in = 6,
        checked_out = 7,
        cancelled = 8,
        
    }
    export enum PmsSpaAppointmentStatus {
        none = 0,
        temporary = 1,
        option = 2,
        reserved = 3,
        confirmed = 4,
        no_show = 5,
        cancelled = 6,
        
    }
    export enum PmsSpaAvailability {
        notAvailable = 0,
        onRequest = 1,
        onRequest2 = 2,
        available = 3,
        
    }
    export enum SpendingMarketingCategory {
        online = 0,
        print = 1,
        ota = 2,
        software = 3,
        design = 4,
        other = 9,
        
    }
    export enum ContractAdoptionType {
        none = 0,
        change = 1,
        termination = 2,
        obsolete = 100,
        
    }
    export enum ProfileContactValuesType {
        country = 0,
        province = 1,
        municipality = 2,
        nationality = 3,
        
    }
    export enum PayrollOffice {
        None = 0,
        Internal = 1,
        External_Giotto = 100,
        External_Personio = 101,
        External_Sage = 102,
        
    }
    export enum PayrollExternalServiceState {
        None = 0,
        Published = 1,
        Processing = 2,
        Done = 3,
        Error = 4,
        Suspended = 5,
        
    }
    export enum PayrollExternalServiceLogType {
        New = 0,
        Update = 1,
        Termination = 2,
        
    }
//}